import { render } from "./PointManageView.vue?vue&type=template&id=dd160562&scoped=true"
import script from "./PointManageView.vue?vue&type=script&lang=js"
export * from "./PointManageView.vue?vue&type=script&lang=js"

import "./PointManageView.vue?vue&type=style&index=0&id=dd160562&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd160562"]])

export default __exports__